// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__qSgku","col":"Table_col__2G-Fs","fulfillmentStatus":"Table_fulfillmentStatus__2eDwB","emailCol":"Table_emailCol__20I7V"};